"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.intentColorSelector = void 0;

var _escapeCss = require("../../escapeCss");

var mapIntentToBaseColor = function mapIntentToBaseColor(intent) {
  /* eslint-disable padding-line-between-statements */
  switch (intent) {
    case "danger":
    case "success":
    case "warning":
    case "primary":
      return intent;

    case "info":
      return "primary";

    default:
      return undefined;
  }
  /* eslint-enable */

};

var intentColorSelector = function intentColorSelector(props, intentColor, intensity) {
  var _props$theme, _props$theme$intentCo, _props$theme$intentCo2;

  var color = mapIntentToBaseColor(intentColor);

  if (!color) {
    return undefined;
  }

  return (0, _escapeCss.escapeCss)((_props$theme = props.theme) === null || _props$theme === void 0 ? void 0 : (_props$theme$intentCo = _props$theme.intentColors) === null || _props$theme$intentCo === void 0 ? void 0 : (_props$theme$intentCo2 = _props$theme$intentCo[color]) === null || _props$theme$intentCo2 === void 0 ? void 0 : _props$theme$intentCo2["$".concat(String(intensity).padStart(3, "0"))]);
};

exports.intentColorSelector = intentColorSelector;